import { COLOR } from '@src/styles/color';

export const DUB_FILE_FORMAT = ['srt'];

export const DUBBING_ERROR = {
  EMPTY_TITLE: 'textTitleError',
};

export const DUBBING_LENGTH_LIMIT = 4; // hours

export const SUBTITLE_SAMPLE_LINK =
  'https://vbee.s3.ap-southeast-1.amazonaws.com/subtitles/sample_file.srt';

export const SUBTITLE_SAMPLE_LINK_PROJECT =
  'https://vbee-aivoice.s3.ap-southeast-1.amazonaws.com/dubbing/sample_subtitle.srt';

export const MAX_FILE_NAME_LENGTH = 50;

export const SUBTITLES_S3_DIRECTORY = 'subtitles';

export const MAX_SENTENCE_LENGTH = 500;

export const ERROR_TYPES = {
  INVALID_SRT_FORMAT: 'invalidSrtFormat',
  INVALID_TIME_DELTA_FORMAT: 'invalidTimeDeltaFormat',
  START_TIME_GREATER_THAN_END_TIME: 'startTimeGreaterThanEndTime',
  AUDIO_TIMESTAMPS_NOT_IN_ORDER: 'audioTimestampsNotInOrder',
};

export const ERROR_SEPARATOR = '<br/>----------------<br/>';

export const ERROR_SEPARATOR_PROJECT = '----------------<br/>';

export const DUBBING_VIDEO_SOURCE = {
  YOUTUBE: 'youtube',
  LOCAL: 'local',
};

export const INPUT_FILE_TYPES = {
  SRT: 'srt',
  YOUTUBE: 'youtube',
  VIDEO: 'video',
  MP4: 'mp4',
};

export const PROJECT_STATUS = {
  DRAFT: 'DRAFT',
  IN_PROGRESS: 'IN_PROGRESS',
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
};

export const REGEX_YOUTUBE_LINK =
  /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\/(watch\?v=|embed\/|v\/|.+\?v=)?([^&=%]{11})/;

export const SRT_FRANC_LANGUAGE_CODE = {
  cmn: 'zh-CN',
  spa: 'es-ES',
  eng: 'en-US',
  rus: 'ru-RU',
  arb: 'ar-SA',
  ben: 'bn-IN',
  hin: 'hi-IN',
  por: 'pt-BR',
  ind: 'id-ID',
  jpn: 'ja-JP',
  fra: 'fr-FR',
  deu: 'de-DE',
  kor: 'ko-KR',
  tel: 'te-IN',
  vie: 'vi-VN',
  mar: 'mr-IN',
  ita: 'it-IT',
  tam: 'ta-IN',
  tur: 'tr-TR',
  urd: 'ur-PK',
  pol: 'pl-PL',
  ukr: 'uk-UA',
  mal: 'ml-IN',
  tha: 'th-TH',
};

export const ASPECT_RATIO_VALUES = {
  ORIGINAL: 'original',
  R_16_9: '16:9',
  R_9_16: '9:16',
  R_4_5: '4:5',
  R_1_1: '1:1',
  R_3_4: '3:4',
};

export const VIDEO_ASPECT_RATIOS = [
  {
    value: ASPECT_RATIO_VALUES.ORIGINAL,
    labelKey: 'originalRatio',
    descriptionKey: '',
    iconName: 'CropFreeRounded',
    width: null,
    height: null,
  },
  {
    value: ASPECT_RATIO_VALUES.R_1_1,
    labelKey: '1:1',
    descriptionKey: 'facebookInstagram',
    iconName: 'CropSquareRounded',
    width: 1,
    height: 1,
  },
  {
    value: ASPECT_RATIO_VALUES.R_16_9,
    labelKey: '16:9',
    descriptionKey: 'youtubeLongForm',
    iconName: 'CropLandscapeRounded',
    width: 16,
    height: 9,
  },
  {
    value: ASPECT_RATIO_VALUES.R_9_16,
    labelKey: '9:16',
    descriptionKey: 'tiktokReelsShorts',
    iconName: 'CropPortraitRounded',
    width: 9,
    height: 16,
  },
  {
    value: ASPECT_RATIO_VALUES.R_4_5,
    labelKey: '4:5',
    descriptionKey: 'linkedinFacebookInstagram',
    iconName: 'Crop32Rounded',
    width: 4,
    height: 5,
  },
  {
    value: ASPECT_RATIO_VALUES.R_3_4,
    labelKey: '3:4',
    descriptionKey: 'facebookInstagram',
    iconName: 'Crop32Rounded',
    width: 3,
    height: 4,
  },
];

export const DEFAULT_VIDEO_BACKGROUND_COLOR = COLOR.black.default;

// Cap for the preview canvas: a 4K backing store costs more per frame than the
// preview box can show.
export const MAX_CANVAS_DIMENSION = 1920;

// Left panel of the video project editor.
export const DUBBING_PANEL_VIEW = {
  BLOCK_LIST: 'BLOCK_LIST',
  CAPTION_STYLES: 'CAPTION_STYLES',
  CAPTION_CONFIG: 'CAPTION_CONFIG',
};

export const CAPTION_PANEL_WIDTH = 512;

// "Không hiển thị phụ đề" là tuỳ chọn phía client, không phải một style của API.
export const CAPTION_STYLE_NONE = 'none';

// The project's own style before the API has named it.
export const CAPTION_STYLE_CUSTOM = 'custom';

// Face style as the font catalogue names it. Mirrors FONT_STYLE on the API.
export const FONT_STYLE = {
  NORMAL: 'NORMAL',
  ITALIC: 'ITALIC',
};

// weight -> i18n key for its label.
export const CAPTION_FONT_WEIGHT_LABELS = {
  100: 'captionFontWeightThin',
  200: 'captionFontWeightExtraLight',
  300: 'captionFontWeightLight',
  400: 'captionFontWeightRegular',
  500: 'captionFontWeightMedium',
  600: 'captionFontWeightSemiBold',
  700: 'captionFontWeightBold',
  800: 'captionFontWeightExtraBold',
  900: 'captionFontWeightBlack',
};
